export default {
  page: {
    title: {
      base: 'Maksevärav Automaatne makse',
      start: 'Makseviisi valimine',
      result: 'Korduv BLIK makse',
      visadata: 'VisaMobile',
      continue: 'Jätka – makseviisi valimine',
      wait: 'Oota',
      confirmation: 'Makse kinnitus',
      thankYou: 'Täname makse eest',
      error: 'Veebisaidi viga',
      errorNotFound: 'Lehte ei leitud',
      secureBack: 'Laadija',
      maintenance: 'Hooldus',
      regulationsApproval: 'Määrused ja privaatsuspoliitika',
      toTransferData: 'ülekande üksikasjad',
      sessionTimeout: 'Lehekülg pärast seansi lõppu',
      paywayError: 'Maksekanal pole saadaval'
    }
  },
  header: {
    availabilityAdjust: {
      increaseFontSize: 'Suurendage fondi suurust',
      decreaseFontSize: 'Vähendage fondi suurust',
      changeContrast: 'Muutke kontrasti',
      changeLanguage: 'Muutke saidi keelt',
      skipToContent: 'Mine sisu juurde',
      skipToContentLabel: 'Mine põhisisu juurde',
      logoTitle: 'Maksevärav Autopay',
      langLoading: 'Keele laadimine',
      langChanged: 'Keel on muudetud'
    },
    sessionTimer: {
      timeOut: 'Seanss aegunud',
      sessionEnd: 'Seansi lõpp:',
      label: 'Pikendage seansi aega',
      button: 'Pikenda'
    }
  },
  footer: {
    text1: 'Kas teil on veebimaksete või meie muude teenuste kohta lisaküsimusi? <a title="It opens in a new window" href="https://pomoc.autopay.pl/?pk_campaign=paywall&pk_kwd=start&pk_medium=hyperlink" class="footer-text-link" target="_blank" rel="noreferrer">Minge abilehele</a>',
    text2: {
      part1: 'Isikuandmete vastutav töötleja on Autopay',
      part2: 'Powstańców Warszawy 6, 81-718 Sopot. Isikuandmete esitamine on vabatahtlik, kuid esitatud taotluse menetlemiseks vajalik. Isikuandmete töötlemise õiguslik alus, eesmärk, periood ja kasutaja õigused, samuti muu oluline teave isikuandmete töötlemise põhimõtete kohta on üksikasjalikult kirjeldatud <a href="{privacyPolicyUrl}" class="footer-text-link" target="_blank" title="Mine privaatsuspoliitika dokumendi lehele (128 KB, PDF)" rel="noreferrer">Autopay S.A. privaatsuspoliitikas</a>'
    },
    linkShowMoreTitle: 'Näita rohkem teavet',
    linkShowMoreText: 'Loe edasi',
    linkShowLessTitle: 'Näita vähem teavet',
    linkShowLessText: 'Loe vähem'
  },
  paywall: {
    header: 'Valige makseviis',
    info: {
      paywayNotAvailable: 'Kahjuks näib, et teie valitud makseviis pole teie seadmes praegu võimalik.',
      applePayNotAvailable: 'Kahjuks ei ole teie seadmes praegu võimalik Apple Payga maksta.',
      googlePayNotAvailable: 'Kahjuks ei ole teie seadmes praegu võimalik Google Payga maksta.'
    },
    paywayGroup: {
      inactiveMessage: 'Makse ei ole hetkel saadaval',
      notice: {
        novelty: 'UUS',
        promotion: 'EDENDAMINE',
        recommended: 'SOOVITATAV',
        mastercard: 'KIIRE JA OHUTU',
        mastercardC2P: 'KIIRE JA OHUTU',
        blik: 'BLIKOMANIA – registreeru ja võida teemante!',
        visaMobile: 'Maksa sujuvalt ja turvaliselt'
      },
      bank: {
        many: 'pangad',
        one: 'pank',
        two: 'pangad'
      },
      wallet: {
        many: 'rahakotid',
        one: 'rahakott',
        two: 'rahakotid'
      },
      otp: {
        many: 'viise',
        one: 'viisil',
        two: 'viise'
      },
      blikPayLater: {
        text1: 'Osta kohe, maksa 30 päeva jooksul – ilma lisakuludeta. BLIK-koodi sisestades saate ostulimiidiks kuni 4000 PLN.',
        text2: 'Teenus saadaval aadressil:'
      },
      blikAuto: {
        bankList: 'Teenus saadaval:',
        infoModel0: 'Hilisemad maksed debiteeritakse teie kontolt automaatselt.',
        infoModelM: 'Hilisemate maksete tegemiseks on vaja ainult kinnitust teie panga taotluses.'
      }
    },
    paywayList: {
      label: 'Maksetüübi rühm',
      linkSelectOther: 'Valige muu'
    },
    paywaySingle: {
      accountAtAnotherBank: 'Mul on konto teises pangas'
    },
    paywaySwitch: {
      methodShortSingle: 'Ühekordne',
      methodLongSingle: 'Ühekordsed maksed',
      methodShortAuto: 'Korduv',
      methodLongAuto: 'Korduvad maksed'
    },
    form: {
      payway: {
        label: 'Valige oma makseviis'
      },
      card: {
        label: 'Sisestage kaardi andmed',
        flowLabel: 'Maksekaart',
        iframe: {
          title: 'Krediitkaardi andmete vorm tuleb täita'
        }
      },
      visaMobile: {
        flowLabel: 'Telefoninumber',
        iframe: {
          title: 'Vorm telefoninumbriga, mis tuleb täita'
        },
        status: {
          pending: {
            statusText: 'Ootab kinnitust',
            header: 'Kinnitage makse rakenduses',
            descriptionText1: 'Makse saate kinnitada Visa Mobile rakenduses või pangarakenduses, kus Visa Mobile on aktiveeritud',
            descriptionText2: 'Pärast tehingu kinnitamist rakenduses oodake maksetulemust',
            descriptionText3: 'Tehingu tühistamine on pooleli',
            cancelButton: 'Tühista makse'
          },
          success: {
            statusText: 'Täname ostu sooritamise eest!',
            descriptionText: 'Makse sooritamine õnnestus'
          },
          error: {
            statusText: 'Palun veenduge, et teie Visa Mobile\'i maksete jaoks kasutataval maksekaardil on piisavalt vahendeid.',
            descriptionText: 'Makse lükati tagasi'
          }
        },
        apps: 'Visa mobiilimaksete rakendused',
        help: 'Kas vajate abi?',
        info: 'Lisateavet',
        secure: 'Turvaline makse SSL-krüptimisega',
        modal2: {
          header: 'Makse kinnitamiseks avage Visa Mobile või selle panga äpp, kus olete Visa Mobile aktiveerinud',
          listText1: 'teil on Visa Mobile installitud või Visa Mobile on teie panga mobiilirakenduses aktiivne',
          listText2: 'teil on Visa mobiilirakenduses või aktiivse Visa mobiiliteenusega pangarakenduses lubatud märguanded',
          listText3: 'sisestatud number on õige: <strong class="no-wrap">+{prefix} {phone}</strong>',
          listText4: 'Veenduge ka, et...'
        }
      },
      click2pay: {
        loaderText: 'Otsime teie e-posti aadressi<br> jaotises <strong>Maksmiseks klõpsa</strong>',
        saveCard: {
          text1: 'Salvestage oma kaart',
          text2mc: 'Teie andmed salvestatakse turvaliselt <strong>Mastercard Click to Pay</strong>',
          text2visa: 'Teie andmed salvestatakse turvaliselt teenusesse <strong>Visa Click to Pay</strong>',
          link: 'Lisateavet'
        },
        email: {
          labelForClick2Pay: 'E-posti aadress makseteatiste jaoks'
        },
        cardSelect: {
          selected: 'Valitud',
          select: 'Valige',
          payOther: 'Sisestage oma kaardi andmed',
          back: 'Tagasi'
        },
        cardSelected: {
          header: 'Kasutage Click to Pay salvestatud kaarti',
          date: 'kehtib kuni',
          buttonChange: 'Muuda'
        },
        codeForm: {
          description: 'Leidsime teie e-posti aadressi jaotisest Click to Pay.',
          codeSentEmail: 'Sisestage oma kontole sisselogimiseks ühekordne kood, mille saatsime aadressile {email}.',
          codeSentPhone: 'Sisestage oma kontole sisselogimiseks ühekordne SMS-kood, mille saatsime numbrile {phone}.',
          codeSent: 'Sisestage oma kontole sisselogimiseks ühekordne kood, mille saatsime aadressile {validationChannel}.',
          codeLabel: 'Sisestage kood',
          codePlaceholder: 'sisestage kood',
          codeLabelFlow: 'Kood',
          codeSendLabel: 'Saada uus kood',
          codeSendAriaLabel: 'kaudu',
          codeSendAriaLabel2: 'või',
          buttonSendNewSms: 'SMS',
          buttonSendNewEmail: 'e-mail',
          trustedLabel: 'Lisage see seade oma usaldusväärsete loendisse<br><span>Järgmisel korral tunneme selle seadme ära ja maksate sisse logimata</span>',
          buttonSubmit: 'Edasi',
          buttonChangeCard: 'Sisestage oma kaardi andmed'
        },
        info: {
          description: 'Kaardimaksed on krüpteeritud ja turvalised. Tehing autoriseeritakse panga veebisaidil 3DSecure\'i abil.'
        },
        loginForm: {
          emailLabel: 'Kliki maksmiseks sisselogimiseks sisestage oma e-posti aadress',
          emailPlaceholder: 'meiliaadress',
          emailLabelFlow: 'Meil',
          buttonSubmit: 'Logi sisse',
          buttonBack: 'Tagasi'
        },
        newUserForm: {
          header: 'Salvestage kaart klõpsuga maksmiseks',
          description: 'Vajame teie kaardi salvestamiseks veel mõnda üksikasju.',
          emailLabel: 'Sisestage e-posti aadress',
          emailPlaceholder: 'meiliaadress',
          emailLabelFlow: 'Meil',
          countryLabel: 'Riik',
          firstnameLabel: 'Nimi',
          firstnamePlaceholder: 'nimi',
          firstnameLabelFlow: 'Nimi',
          lastnameLabel: 'Perekonnanimi',
          lastnamePlaceholder: 'perekonnanimi',
          lastnameLabelFlow: 'Perekonnanimi',
          phoneLabel: 'Telefoninumber',
          phonePlaceholder: 'telefoninumber',
          phoneLabelFlow: 'Telefon',
          countryCodePlaceholder: 'kood',
          countryCodeLabelFlow: 'Kood',
          trustedLabel: 'Lisage see seade oma usaldusväärsete loendisse<br><span>Järgmisel korral tunneme selle seadme ära ja maksate sisse logimata</span>',
          termsMastercardLabel: 'Jätkates nõustute <a href="https://www.mastercard.com/global/click-to-pay/country-listing/terms.html" target="_blank">kasutustingimustega</a> ja mõistate, et teie andmeid töödeldakse vastavalt Mastercardi <a href="https://www.mastercard.com/global/click-to-pay/country-listing/privacy.html" target="_blank">privaatsuspoliitikale</a>.',
          termsVisaLabel: 'Jätkates nõustute <a href="{c2pVisaTermsUrl}" target="_blank">Visa Solutioni teenusetingimustega</a> ja mõistate, et teie andmeid töödeldakse vastavalt <a href="{c2pVisaPrivacyUrl}" target="_blank">Visa privaatsuseeskirjadele</a>.',
          cookieVisaLabel: 'Jätkates nõustute <a href="{c2pVisaCookieUrl}" target="_blank">Visa küpsiste eeskirjadega</a>.',
          c2pInfo: 'Teie kinnitamiseks kasutatakse teie e-posti või mobiiltelefoni numbrit. Rakenduda võivad sõnumi-/andmesidetasud.',
          buttonSubmit: 'Säästa ja maksa',
          buttonBack: 'Makske ilma kaarti salvestamata'
        },
        profile: {
          header: 'Logige sisse, et maksta klõpsuga',
          buttonChangeEmail: 'Muuda meiliaadressi'
        },
        modal: {
          title: 'Klõpsake maksmiseks – teave',
          header: 'Makske kiiresti ja turvaliselt ilma kaardiandmeid uuesti sisestamata uues Click to Pay standardis',
          text1: 'Kaardiga makstes otsi üles logo <img src="/web/img/click2pay/Click_to_Pay.svg" style="height: 14px" alt="Click to Pay Logo"> ning makske kaardimaksega kiiresti ja mugavalt.',
          text2: 'Click To Pay on uus kaardimaksete standard, mida toetavad Visa ja Mastercard.',
          text3: 'Saate oma Click to Pay kontol olevat kaarti kasutada Poola ja välismaal asuvates kauplustes maksmiseks ilma kaardiandmeid uuesti sisestamata.',
          text4: 'Andmed salvestatakse turvaliselt Visa või Mastercard kaardile. Kogu teave on täielikult krüpteeritud.',
          text5: 'Edasiste maksete ajal tuvastab Click to Pay teie e-posti aadressi, et saaksite koheselt maksta salvestatud kaartidega.',
          text6: 'Lisaks kinnitate kõik maksed oma pangaga, mis tagab täieliku turvalisuse.',
          processError: 'Teie Click-to Pay-makse töötlemisel ilmnes viga. Tehke tavaline kaardimakse.'
        }
      },
      email: {
        label: 'Anna oma e-posti aadress',
        flowLabel: 'E-post',
        tip: 'Vajame teie e-posti aadressi, et saaksime teile teie makseoleku kohta sõnumeid saata.',
        fuse: 'Veenduge, et teie e-posti aadress on õigesti sisestatud.'
      },
      blikCode: {
        label: 'Sisestage BLIK-kood',
        flowLabel: 'CAN-kood'
      },
      terms: {
        header: 'Nõusolekud ja avaldused',
        selectAll: 'Valige kõik',
        fieldNotRequired: 'Valikuline väli',
        partnerMarketingTextLess: 'Kas soovite saada meilt, SMS-i või telefoni teel teateid meie või meie partnerite korraldatud parimate pakkumiste, tutvustuste, konkursside ja muude huvitavate sündmuste kohta?',
        partnerMarketingTextMore: 'Lubame mitte rämpsposti saata! Kui teil on meie sõnumitest igav, võite oma nõusoleku igal ajal tagasi võtta.',
        tradeMarketingTextLess: 'Kas soovite, et edastaksime teie e-posti või telefoninumbri meie usaldusväärsetele partneritele, et nad saaksid teile huvitavat teavet ja pakkumisi pakkuda?',
        tradeMarketingTextMore: 'Tagame, et meie partnerid on hea mainega ettevõtted, kellele nagu meiegi ei meeldi rämpspostitus, ja te saate oma nõusoleku igal ajal tagasi võtta.'
      },
      termsFlowLabel: 'Eeskirjad',
      termsLabelDefault: 'Olen lugenud läbi <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Download the terms of service file" rel="noreferrer">Makseteenuse tingimused</a> ja <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="S.">Laadige alla privaatsuspoliitika fail.</a> Soovin, et teenust osutataks kohe ja lepingust taganemise korral tean, et mulle ei hüvitata minu nõudmisel enne lepingust taganemist osutatud teenuste eest tehtud kulutusi.',
      termsReccuring: 'Kui soovite makse sooritada, nõustuge <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Download the terms of service file" rel="noreferrer">teenusetingimustega</a> ja <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="Privaatsuspoliitika fail</a>A">Laadige alla privaatsuspoliitika fail A.A. Autopay S.A., nõusolek kohese makseteenuse kasutamiseks ja nõusolek minu maksekaardilt tasu võtta.',
      termsReccuringMore1: 'Nõustun teenuse viivitamatu osutamisega ja tunnistan, et lepingust taganemise korral ei hüvitata mulle enne lepingust taganemist minu nõudmisel osutatud teenuste eest tekkinud kulusid.',
      termsReccuringMore2: 'Nõustun sellega, et Autopay S.A. võtab minu maksekaardilt korduvaid tasusid, et teha tehing kasutaja {receiverName} kasuks. Korduva kaarditasu tingimused on määratletud <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Download the terms of service file" rel="noreferrer">makseteenuse tingimustega</a>. Kinnitan käesolevaga, et tean oma maksekaardile võetavate summade määramise perioode, sagedust ja reegleid ning nõusoleku tagasivõtmise viisi, mille olen kehtestanud ettevõttega {receiverName}. Maksekaardilt korduvat tasu puudutavate küsimuste korral võtan kasutajaga {receiverName} ühendust.',
      mwfClauseLess: 'Kui soovite makse sooritada, nõustuge <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Download the file with the Terms of Service" rel="noreferrer">nõuete ja tingimustega</a> ja <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank"">Privaatsuspoliitika faili koos poliitikaga "A. privaatsuspoliitika allalaadimine. Autopay S.A.</a>, nõustuge alustama teie pangas tehingut Autopay S.A. kaudu, esitage saajale selle tehingu üksikasjad ja taotlege makseteenuse viivitamatut täitmist.',
      mwfClauseMore: 'Soovin, et teenust osutataks koheselt ja tean, et lepingust taganemise korral tekkinud kulusid ma tagasi ei saa.',
      mwfClauseARIA: 'Kui soovite makset teha, palun nõustuge Autopay S.A. eeskirjade ja privaatsuspoliitikaga, andke nõusolek tehingu algatamiseks oma pangas Autopay S.A. kaudu ja edastage saajale selle tehingu üksikasjad ning taotlege makseteenuse viivitamatut teostamist. Soovin, et teenus osutataks viivitamatult ja mõistan, et lepingust taganemise korral ma raha tagasi ei saa. <a href="{regulationUrl}" class="form-text-link" target="_blank" title="" rel="noreferrer" tabindex="-1">Laadige alla teenuse tingimustega fail</a> <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="" tabindex="-1">Laadige alla Autopay S.A. privaatsuspoliitikaga fail</a>',
      paymentInfo: 'Maksekorraldus esitatakse teie pangale Sopotis asuva Autopay S.A. kaudu ja seda töödeldakse vastavalt teie panga tingimustele. Pärast panga valimist autoriseerite makse.',
      changePaywayLink1: 'Ikka saab',
      changePaywayLink2: 'muuta makseviisi',
      linkMore: 'VEEL',
      linkShowMoreTitle: 'Kuvage lisateavet',
      linkLess: 'VÄHEM',
      linkShowLessTitle: 'Peida lisateave',
      submitButton: {
        visaMobile: 'Maksa järgi',
        fastTransfer: 'Looge ülekande üksikasjad',
        mwf: 'Võtan vastu ja maksan',
        pis: 'Nõustun ja alustan maksmist',
        auto: 'Korduva makse tellimine',
        autoPayment: 'Tellimuse tasumine',
        other: 'Maksa kohe',
        orange: 'Kinnita',
        c2pNext: 'Edasi',
        c2pAccept: 'nõustun',
        c2pSaveAndPay: 'Säästa ja maksa',
        ariaLabelInactive: 'Jätkamiseks täitke kohustuslikud väljad õigesti'
      }
    },
    frData: {
      pageTitle: 'Üksikasjalikud andmed ülekandmiseks',
      header: 'Tellige ülekanne, kasutades esitatud andmeid',
      nrbLabel: 'Saaja konto',
      nameLabel: 'Saaja nimi',
      addressLabel: 'Saaja aadress',
      titleLabel: 'Ülekande nimi',
      amountLabel: 'Ülekande summa',
      timeLabel: 'Tehingu teostamiseks',
      linkCopy: 'Kopeeri',
      linkGetPdf: 'Laadige alla andmetega PDF',
      linkGetPdfTitle: 'See avaneb uues aknas',
      linkGoToBank: 'Logige panka sisse',
      info: 'Logige sisse oma pangakontole. Kopeerige üksikasjad ülekandesse. Oluline on, et andmed oleksid samad, ei muuda summat, valuutat ega pealkirja vms.',
      verifyInfo: 'Teie panga kinnitamine võib võtta kuni 3 päeva, kuna kiiret ülekannet ei saa töödelda. Võite jätkata või kinnitada oma pangakonto muul viisil. Kui soovite valida mõne muu meetodi, klõpsake <strong>{backToShopText}</strong> ja naaske Fortuna veebisaidile.'
    },
    frInfo: {
      paywall: {
        text1: 'See makseviis ei toeta rahvusvahelisi ülekandeid.',
        text2: 'Välispankadest tehtud ülekandeid ei töödelda.'
      },
      frData: {
        text1: 'Märkus: Ärge muutke ülekande nime ega summat.',
        text2: 'Nende andmete muutmine võib takistada makse õiget laekumist.'
      }
    },
    processing: {
      pageTitle: 'Tehingu töötlemise ooteleht',
      loaderAnimation: 'Ooteajal kuvatakse animatsioon',
      header: 'Valmistame ette teie makselehte.',
      description: 'Palun oodake hetk...',
      info: {
        header: 'Märkus!',
        description: 'Ärge sulgege lehte pärast tehingu sooritamist – vastasel juhul ei saadeta teie raha saajale.'
      },
      loaderText: 'Andmeedastus on pooleli.<br>Meil kulub selleks maksimaalselt 30 sekundit.'
    }
  },
  thankYou: {
    pageTitle: 'Teave tehingu tulemuse kohta',
    form: {
      emailLabel: 'E-post',
      buttonSubmit: 'Tagasi partnerite lehele'
    },
    negative: {
      header: 'Makset ei töödeldud tehinguvolituse puudumise tõttu.',
      description: 'Kui soovite siiski kasutada konkreetse jaemüüja või teenusepakkuja pakkumist, minge tagasi nende veebisaidile, valige toode või teenus ja sooritage makse oma valitud viisil.'
    },
    pending: {
      header: 'Täname, et tellisite makse läbi maksevärava',
      description: 'Tehingu oleku kontrollimine on pooleli. Kui protsess on lõpule viidud, saate oma e-posti postkasti teabe makse oleku kohta.'
    },
    positive: {
      header: 'Täname, teie makse on töödeldud.',
      description: 'Saadame kinnituse Teie poolt antud e-posti aadressile.'
    }
  },
  regulationsApproval: {
    header: 'Aktsepteeri tehing'
  },
  wait: {
    pageTitle: 'Ooteleht'
  },
  sessionTimeout: {
    pageTitle: 'Lehekülg pärast seansi lõppu',
    header: 'Makse sooritamise aeg on möödas',
    description: 'Saate igal ajal naasta partneri saidile, uuesti tellida või teenust kasutada ja tasuda enda valitud meetodil.'
  },
  paywayError: {
    pageTitle: 'Valitud maksekanal pole saadaval',
    header: 'Kahjuks pole valitud makseviis hetkel saadaval.',
    description: 'Palun naaske partnerite lehele ja proovige hiljem uuesti.'
  },
  loader: {
    loading: 'Laadimine',
    defaultAnimation: 'Lehe laadimise ajal kuvatakse animatsioon',
    slider: 'Muutuvate tekstidega liugur',
    text1: 'Me püüdleme Autopays süsinikuneutraalsuse poole. Ja seda teete ka teie, kui kasutate meie teenuseid.',
    text2: 'Autopays sõidame rattaga tööle, vähendades kasvuhoonegaaside heitkoguseid atmosfääri. Ja seda teete ka teie, kui kasutate meie teenuseid.',
    text3: 'Autopays töötab meid roheline energia. Nii ka teie, kui kasutate meie teenuseid.',
    text4: 'Autopays vähendame paberitarbimist. Ja seda teete ka teie, kui kasutate meie teenuseid.',
    rateLimitExceeded: 'Tehinguliiklus on suurenenud, seega võib teie makse töötlemine võtta tavapärasest kauem aega. Palun oodake ja ärge värskendage makselehte.'
  },
  result: {
    pending: {
      header: 'Kinnitage korduv BLIK-makse',
      description: 'Avage oma pangarakendus ja kinnitage makse'
    },
    positive: {
      initWithPayment: {
        header: 'Tasuline',
        description: 'Oleme teie raha saajale üle kandnud. Kaupmehelt või teenusepakkujalt saate lõpliku kinnituse BLIK korduva makse aktiveerimise kohta.',
        button: 'Tagasi saidile'
      },
      initWithRefund: {
        header: 'Valmis',
        description1: 'Oleme teie tellimuse kätte saanud ja edastanud töötlemiseks. Lõpliku kinnituse saate otse poest.',
        description2: 'Summa {amount} {currency} tagastatakse teie pangakontole.',
        button: 'Tagasi saidile'
      },
      initWithoutPayment: {
        header: 'Valmis',
        description: 'Lubame korduvad BLIK-maksed. {shopName} saadab teile peagi teavet.',
        button: 'Tagasi saidile'
      }
    },
    negative: {
      recurrencyNotSupported: {
        header: 'BLIK korduvat makset ei saa lubada',
        description1: 'Te ei saa lubada BLIK korduvaid makseid. See meetod pole praegu teie panga kasutajatele saadaval.',
        description2: 'Proovige uuesti, kasutades toetatud pankade BLIK-koodi või valige mõni muu makseviis.',
        buttonContinue: 'Muutke makseviisi',
        buttonReturn: 'Tagasi saidile'
      },
      wrongTicket: {
        header: 'Vale BLIK-kood',
        description: 'Sisestatud BLIK-kood on vale või aegunud. Kontrollige koodi ja proovige uuesti. Kui probleem püsib, looge oma pangarakenduses uus kood.',
        buttonContinue: 'Muutke makseviisi',
        buttonReturn: 'Tagasi saidile'
      },
      generic: {
        header: 'BLIK korduvat makset ei saa lubada',
        description: 'Te ei saa lubada BLIK korduvaid makseid. Proovige uuesti, kasutades toetatud pankade BLIK-koodi või valige mõni muu makseviis.',
        buttonContinue: 'Muutke makseviisi',
        buttonReturn: 'Tagasi saidile'
      }
    }
  },
  orderDetails: {
    header: 'Üksikasjad',
    headerAriaLabel: 'Tehingu üksikasjad',
    amountLabel: 'Tasumisele kuuluv summa',
    receiverLabel: 'Saaja',
    orderLabel: 'Tellimuse number',
    amountOriginalCurrencyLabel: 'Algne summa',
    currencyRateLabel: 'Valuuta vahetuskurss',
    feeLabel: 'Tehingu käsitlemise tasu',
    feeLabelDcc: 'Valuuta konverteerimise tasu',
    customerNumberLabel: 'Kliendi number',
    invoiceNumberLabel: 'Arve number',
    accountNumberLabel: 'Konto number',
    paywayLabel: 'Makseviis',
    paywayName: 'Internetipanga ülekanne',
    linkBack: 'Tagasi poodi',
    linkBackTitle: 'Jätke tehing ja minge poodi tagasi',
    linkMore: 'näita rohkem',
    linkLess: 'näita vähem',
    toggleBtnUnfoldAriaLabel: 'Laiendage tellimuse üksikasju',
    toggleBtnFoldAriaLabel: 'Ahenda tellimuse üksikasju',
    blikReccuringNameLabel: 'Nimi',
    blikReccuringValidToLabel: 'Aegumiskuupäev',
    blikReccuringValidToText: 'määramata ajaks',
    blikReccuringFrequencyLabel: 'Sagedus',
    blikReccuringFrequencyText: 'Iga kord, kui teenust kasutate'
  },
  error: {
    pageTitle: 'Vealeht',
    linkBackUrlSet: 'Tagasi partneri saidile',
    linkBackUrlNotSet: 'Minge abilehele',
    sessionTimeout: {
      title: 'Makse sooritamise aeg on möödas',
      message: 'Saate igal ajal naasta partneri saidile, uuesti tellida või teenust kasutada ja tasuda enda valitud meetodil.'
    },
    notFoundError: {
      pageTitle: 'Vea lehekülg 404 – lehte ei leitud',
      title: 'Näib, et sõitsite liiga kaugele ega leidnud lehte, mida soovite külastada.',
      message: 'Võimalikud põhjused: leht puudub või on eemaldatud, hooldus on pooleli, lehe aadress on vale, ilmnes tehniline viga.'
    },
    generalError: {
      title: 'Vabandust',
      message: 'Me ei saa teie ülekannet praegu töödelda.'
    },
    errFieldNotFound: {
      title: 'Vabandust',
      message: ''
    },
    errBadClientSource: {
      title: 'Vabandust',
      message: ''
    },
    nrParametersError: {
      title: 'Vabandust',
      message: 'Me ei saa teie ülekannet praegu töödelda.'
    },
    transactionOutdated: {
      title: 'Makse sooritamise aeg on möödas.',
      message: 'Telli uuesti.'
    },
    linkValidityTimeOutdated: {
      title: 'Makse sooritamise aeg on möödas.',
      message: 'Telli uuesti.'
    },
    transactionValidityTimeOutdated: {
      title: 'Makse sooritamise aeg on möödas.',
      message: 'Telli uuesti.'
    },
    multiplyTransaction: {
      title: 'Vabandust',
      message: 'Tehing on juba olemas ja ootab tasumist.'
    },
    transactionCanceled: {
      title: 'Vabandust',
      message1: 'Tehing tühistati.',
      message2: 'Telli uuesti.'
    },
    multiplyPaidTransaction: {
      title: 'Vabandust',
      message: 'Tehingu eest on juba tasutud.'
    },
    transactionReject: {
      title: 'Vabandust',
      message1: 'Oih, midagi läks valesti.',
      message2: 'Parandus on pooleli...'
    },
    bankDisabled: {
      title: 'Vabandust',
      message: 'Valitud pank pole praegu saadaval.'
    },
    bankTemporaryMaintenance: {
      title: 'Vabandust',
      message: 'Me ei saa teie ülekannet praegu töödelda.'
    },
    insufficientStartAmount: {
      title: 'Vabandust',
      message: 'Ülekande summa limiit on ületatud.'
    },
    startAmountOutOfRange: {
      title: 'Vabandust',
      message: 'Ülekande summa limiit on ületatud.'
    },
    nonAccountedLimitExceeded: {
      title: 'Vabandust',
      message: 'Makset ei saa töödelda, kuna müüjal on kuu müügilimiit täis.'
    }
  },
  confirmation: {
    pageTitle: 'Teave makseprotsessi kohta',
    linkBack: 'Ma tulen saidile tagasi',
    linkBackTimeout: 'Naaske partneri saidile',
    linkBackTimeoutTime: 'sekundit',
    linkBackAutoRedirect: 'See leht suunatakse automaatselt partneri veebisaidile {time} sekundi pärast. Lehega suhtlemine peatab loenduse.',
    linkBackTimerStopped: 'Automaatne ümbersuunamine on peatatud. Partneri veebisaidile naasmiseks kasutage nuppu Tagasi saidile.',
    incorrectAmount: {
      header: 'Vale summa',
      description: 'Me ei kandnud teie makset saajale üle, kuna summa oli vale.',
      description2: 'Lehele naasmiseks ja uuesti tegemiseks klõpsake nuppu. Ärge unustage andmeid mitte muuta.'
    },
    multiplePaid: {
      header: 'Kahekordne sissemakse',
      description: 'Saaja sai teie makse kaks korda kätte. Ärge muretsege – saate raha tagasi.',
      description2: 'Võtke saajaga ühendust ja esitage talle maksekinnitus.'
    },
    negative: {
      header: 'Ei mingit makset',
      description: 'Teie makse töötlemisel ilmnes viga. Kuid midagi pole kadunud.',
      description2: 'Lehele naasmiseks ja uuesti tegemiseks klõpsake nuppu.'
    },
    notFound: {
      header: 'Ei mingit makset',
      description: 'Teie makse töötlemisel ilmnes viga. Kuid midagi pole kadunud.',
      description2: 'Lehele naasmiseks ja uuesti tegemiseks klõpsake nuppu.'
    },
    outdated: {
      header: 'Aja lõpp',
      description: 'Me ei kandnud teie makset saajale üle.',
      description2: 'Lehele naasmiseks ja uuesti tegemiseks klõpsake nuppu.'
    },
    outdatedPaidNotRefunded: {
      header: 'Aja lõpp',
      description: 'Me ei kandnud teie makset saajale üle. Kui teie kontolt on raha välja võetud, ärge muretsege, raha saate mõne päeva jooksul tagasi.',
      description2: 'Lehele naasmiseks ja uuesti tegemiseks klõpsake nuppu.'
    },
    outdatedPaidRefunded: {
      header: 'Aja lõpp',
      description: 'Me ei kandnud teie makset saajale üle. Kui raha võeti teie kontolt välja, ärge muretsege, oleme selle juba tagasi maksnud.',
      description2: 'Lehele naasmiseks ja uuesti tegemiseks klõpsake nuppu.'
    },
    pending: {
      header: 'Pooleli',
      description: 'Töötleme teie makset. Anname teile teada, kui see adressaadini jõuab.'
    },
    positive: {
      header: 'Tasuline',
      visaVideo: 'Pärast edukat tehingut esitati reklaamvideo',
      description: 'Oleme teie raha saajale üle kandnud.',
      dccStatement: 'Mul oli võimalus valida valuutad, mida minu makseks kasutatakse. Valisin tehingu valuuta ja nõustusin maksma {currency} näidatud vahetuskursi alusel. Dünaamilist valuutakonverteerimist (DCC) pakub Autopay S.A.'
    }
  },
  messages: {
    accessForbidden: 'Juurdepääs puudub',
    internalServerError: 'Ilmnes ootamatu viga. Proovige hiljem uuesti.',
    validators: {
      required: 'Kohustuslik väli',
      pattern: 'Sisestage kehtiv väärtus',
      blikCode: 'Sisestage 6-kohaline BLIK-kood',
      emailRequired: 'Sisestage õige e-posti aadress',
      emailNotValid: 'Sisestage õige e-posti aadress',
      emailNotRecognized: 'Esitatud e-posti aadress ei ole registreeritud',
      emailIdentityLookup: 'E-posti aadressi ei saanud kinnitada',
      emailLocked: 'Esitatud meiliaadress on Mastercardi süsteemis ajutiselt blokeeritud',
      paywayRequired: 'Maksmiseks valige pank',
      creditCardRequired: 'Täitke kõik väljad',
      phoneRequired: 'Sisestage kehtiv telefoninumber',
      regulationRequired: 'Nõustuge tingimustega',
      requiredConsent: 'Nõusolek on vajalik',
      codeNotValid: 'Esitatud kood ei kehti',
      codeAccountLocked: 'Konto on ajutiselt blokeeritud',
      unknownError: 'Ilmnes ootamatu viga'
    },
    validatorsAria: {
      required: 'Tähelepanu. Vormi väli ei ole täidetud. Kohustuslik väli',
      pattern: 'Tähelepanu. Väljal on vale väärtus.',
      blikCode: 'Tähelepanu. Sisestage 6-kohaline BLIK-kood',
      emailRequired: 'Tähelepanu. Meiliväli ei ole täidetud. Sisestage õige e-posti aadress',
      emailNotValid: 'Tähelepanu. Teie e-posti aadress sisaldab viga. Sisestage õige e-posti aadress',
      emailNotRecognized: 'Tähelepanu. Esitatud e-posti aadress ei ole registreeritud.',
      emailIdentityLookup: 'Tähelepanu. Esitatud e-posti aadressi ei saanud kinnitada.',
      emailLocked: 'Tähelepanu. Esitatud meiliaadress on Mastercardi süsteemis ajutiselt blokeeritud.',
      paywayRequired: 'Tähelepanu. Makse ei ole valitud. Valige makseviis',
      creditCardRequired: 'Tähelepanu. Täitke kõik väljad krediitkaardi andmetega',
      phoneRequired: 'Tähelepanu. Telefoninumbri väli sisaldab viga. Sisestage kehtiv telefoninumber.',
      codeNotValid: 'Tähelepanu. Esitatud kood ei kehti.',
      codeAccountLocked: 'Tähelepanu. Konto on ajutiselt blokeeritud.',
      unknownError: 'Tähelepanu. Ilmnes ootamatu viga.'
    },
    success: {
      copy: 'Kopeeritud!',
      codeSent: 'Kood on saadetud!'
    },
    errors: {
      getPdf: 'PDF-i allalaadimine ebaõnnestus!',
      copy: 'Kopeerimine ebaõnnestus!',
      thankYouUpdate: 'E-posti aadressi salvestamine ebaõnnestus!',
      groupInactive: 'Praegu on grupi {groupName} abil ülekannet võimatu teha. Valige mõni muu makseviis.',
      paywayInactive: 'Hetkel ei ole tehnilistel põhjustel võimalik valitud pangast ülekannet teha. Valige mõni muu pank või makseviis.',
      googlePayInactive: 'Kahjuks pole Google Pay makse teie seadmes saadaval.',
      applePayInactive: 'Apple Pay on saadaval inimestele, kes kasutavad Safari ja iOS-i seadmeid.',
      codeNotSent: 'Koodi uuesti saatmine ebaõnnestus!',
      codeCounterExceeded: 'Lubatud katsete arv on ületatud. Sisestage oma kaardi andmed käsitsi või kasutage mõnda muud makseviisi.'
    }
  },
  modal: {
    closeButton: 'Sule',
    confirmButton: 'ma saan aru'
  },
  configuration: {
    paywayGroups: {
      auto: {
        label: 'Korduv makse',
        description: 'Sisestage maksmiseks kasutatava kaardi andmed. Automaatsed maksed võetakse teie kaardilt hiljem.',
        labelInitWithRefund: 'Kinnitusmakse',
        labelInitWithRefundOrange: 'Lisa maksekaart',
        labelInitWithPayment: 'Kaardimakse',
        descriptionInitWithRefund: 'Sisestage selle kaardi andmed, mida soovite tulevaste maksete jaoks kinnitada. Järgmise sammuna võtame antud kaardilt 1 PLN, et kontrollida andmete õigsust. Pärast kontrollimist tagastame summa.',
        descriptionInitWithPayment: 'Sisestage tehingu tegemiseks kasutatava kaardi andmed ja kinnitage see samal ajal tulevaste maksete jaoks.'
      },
      blik: {
        label: 'VAATA',
        description: 'Makske kohe, sisestades BLIK-koodi, ilma sisselogimiseta ega registreerimata'
      },
      blikAuto: {
        label: 'BLIK korduvad maksed',
        description: 'Saate lubada selle kaupmehe korduvad BLIK-maksed ja järgnevad maksed debiteeritakse teie kontolt automaatselt.'
      },
      card: {
        label: 'Kaardimakse',
        description: 'Makske oma pangakaardiga'
      },
      pbl: {
        label: 'Interneti-ülekanne',
        description: 'Valige pank, kust soovite makse sooritada',
        descriptionVerify: 'Interneti-identiteedi kinnitamine',
        descriptionServiceVerify: 'Valige pank, mis võimaldab teil võrguteenust kontrollida'
      },
      visaMobile: {
        label: 'VisaMobile',
        description: 'Visa Mobiilimakse'
      },
      wallet: {
        label: 'Google&nbsp;Pay | Apple&nbsp;Pay',
        description: 'Makske ilma Interneti-panka sisse logimata'
      },
      installments: {
        label: 'Järelmaks',
        description: 'Tasuge oma ostude eest mugavate järelmaksudega.'
      },
      alior: {
        descriptionInfo1: 'Tasuge oma ostude eest mugavate järelmaksudega.',
        descriptionInfo2: '(kontrollige üksikasju)',
        aliorModal: {
          text1: 'Olenevalt selle veebisaidi seadetest, kus ostu sooritate, saate osta tooteid järelmaksuga järgmistes variantides:',
          text2: '<ul><li>10 osamakset 0%</li><li>20 osamakset 0%</li><li>3 kuni 48 osamakset kuukuluga 1% (vastavalt antud tehingu kohta toodud tüüpilisele näitele)</li></ul>'
        }
      },
      otp: {
        label: 'Maksa hiljem',
        description: 'Osta kohe ja maksa hiljem',
        descriptionInfo1Mwf: 'Tasu arve eest hiljem – üks kord kuni 45 päeva või mitme võrdse osamaksena',
        descriptionInfo1Ecommerce: 'Maksa hiljem – üks kord kuni 45 päeva või mitme võrdse osamaksena',
        descriptionInfo2Mwf: 'Teave krediidivahendaja ja maksumuse kohta',
        descriptionInfo2Ecommerce: 'Kulude teave',
        labelPayka: 'Ta on',
        descriptionPayka: 'Maksa arve eest hiljem – üks kord kuni 30 päeva või 4 võrdse osamaksena <a href="" id="paykaShowInModal">Teave krediidivahendaja ja maksumuse kohta</a>',
        paykaModalMwf: {
          header1: 'Laenumaakleri teade',
          text1: 'Autopay S.A., mille peakontor asub Sopotis, tegutseb laenuvahendajana Paytree S.A.-s, mille peakontor asub Poolas Gdanskis (laenuandja), kes on volitatud klientidele laenupakkumist esitama ja laenuandja veebisaidile, sealhulgas laenutaotlust ümber suunama. Pakkumise üksikasjad leiate aadressilt <a href="https://payka.pl/rachunki-domowe" target="_blank">Majapidamise arved – Payka</a>.',
          header2: 'Kulude üksikasjad',
          text2: 'Maksa hiljem – üks kord kuni 45 päeva või mitme võrdse osamaksena. Kuluandmed tüüpilise näite jaoks: Tagasimakse 45 päeva jooksul APR 0%; Järelmaksu tagasimakse APR 74,11%. Pakkumise üksikasjad: <a href="https://payka.pl" target="_blank">Payka.pl</a>'
        },
        paykaModalEcommerce: {
          header2: 'Kulude üksikasjad',
          text2: 'Maksa hiljem – üks kord kuni 45 päeva või mitme võrdse osamaksena. Kuluandmed tüüpilise näite jaoks: Tagasimakse 45 päeva jooksul APR 0%; Järelmaksu tagasimakse APR 74,11%. Pakkumise üksikasjad: <a href="https://payka.pl" target="_blank">Payka.pl</a>'
        }
      },
      blikPayLater: {
        label: 'BLIK Maksa hiljem',
        description: ''
      },
      companyPayments: {
        label: 'Ärimakse',
        description: 'Lükake ettevõtte ostude maksekuupäev 30 päeva võrra edasi'
      },
      transfer: {
        label: 'Ülekande üksikasjad',
        description: 'Tellige ülekanne, kasutades esitatud üksikasju'
      },
      other: {
        label: 'muud',
        description: ''
      }
    },
    mobileEvents: {
      statusDescription: {
        bankDisabled: 'Vabandust. Me ei saa praegu teie ülekannet töödelda. Valitud pank pole praegu saadaval.',
        blockMultipleTransactions: 'Vabandust. Tehing on juba olemas ja ootab tasumist.',
        blockPaidTransactions: 'Vabandust. Tehingu eest on juba tasutud. Te ei saa makset uuesti teha.',
        canceledTransactions: 'Tehing, mille eest proovite maksta, on tühistatud ja pole saadaval. Palun algata uus tehing.',
        declined: 'Autoriseerimisest keeldumine.',
        generalError: 'Ilmnes ajutine ühenduse probleem. Me ei saa teie ülekannet praegu töödelda. Palun tulge hiljem tagasi.',
        insufficientStartAmount: 'Vabandust. Ülekande summa limiit on ületatud.',
        internalServerError: 'Oopss. toiming nurjus:(. Tegeleme probleemi lahendamisega. Proovige hiljem uuesti.',
        nonAccountedLimitExceeded: 'Makset ei saa töödelda, kuna müüjal on kuu müügilimiit täis.',
        outdatedError: 'Makse sooritamise aeg on möödas.',
        paid: 'Tehing on edukalt lõpule viidud.',
        paywayLoaded: 'Kiire edastuse leht on laaditud',
        paywaylistLoaded: 'Makseviisi valiku leht on laaditud'
      }
    }
  },
  maintenance: {
    text1: 'Käimas on Autopay maksevärava uusaastapuhastus ja seetõttu ei ole hetkel võimalik makseid tellida. Vabandame ebamugavuste pärast.',
    text2: 'Värav hakkab taas elama juba 16. jaanuaril kell 10.',
    text3: 'Täname mõistva suhtumise eest.'
  },
  requiredParams: {
    accountHolderName: {
      label: 'Sisestage konto omaniku andmed',
      flowLabel: 'Konto omanik',
      placeholder: 'Sisestage konto omaniku andmed'
    },
    nip: {
      label: 'Sisestage oma maksukohustuslase number',
      flowLabel: 'NIP',
      placeholder: 'Sisestage oma maksukohustuslase number'
    },
    customerEmail: {
      label: 'Sisesta oma e-mail',
      flowLabel: 'E-post',
      placeholder: 'Sisesta oma e-mail'
    },
    senderIban: {
      label: 'Täitke oma IBAN',
      flowLabel: 'IBAN',
      placeholder: 'Täitke oma IBAN'
    },
    shippingBuildingNumber: {
      label: 'Sisestage hoone number',
      flowLabel: 'Hoone nr.',
      placeholder: 'Hoone nr.'
    },
    shippingPostalCode: {
      label: 'Sisestage sihtnumber',
      flowLabel: 'Postiindeks',
      placeholder: 'Postiindeks'
    },
    shippingStreetName: {
      label: 'Sisestage tänav',
      flowLabel: 'Tänav',
      placeholder: 'Tänav'
    },
    shippingLastName: {
      label: 'Sisestage perekonnanimi',
      flowLabel: 'Perekonnanimi',
      placeholder: 'Perekonnanimi'
    },
    shippingCountryCode: {
      label: 'Sisesta riik',
      flowLabel: 'Riik',
      placeholder: 'vali riik'
    },
    shippingRegion: {
      label: 'Sisesta piirkond',
      flowLabel: 'Piirkond',
      placeholder: 'Piirkond'
    },
    shippingFlatNumber: {
      label: 'Sisesta korteri number',
      flowLabel: 'Apt. ei.',
      placeholder: 'Apt. ei.'
    },
    shippingFirstName: {
      label: 'Sisestage eesnimi',
      flowLabel: 'Eesnimi',
      placeholder: 'Eesnimi'
    },
    shippingCity: {
      label: 'Sisestage linn',
      flowLabel: 'Linn',
      placeholder: 'Linn'
    }
  },
  survey: {
    skipSurvey: 'Jäta küsitlus vahele',
    skipSurveyLabel: 'Jäta küsitluse jaotis vahele',
    sectionLabel: 'Küsitlus'
  }
}
